import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';
import { LandingpageConfigurationStateService } from '../services/state/landingpage-configuration-state.service';
import { AuthenticationStateService } from '../services/state/authentication-state.service';
import { BackendErrorType } from '../services/errors/backend.errors';

export const landingpageConfigurationGuard: CanActivateChildFn = async () => {
  const router = inject(Router);
  const landingpageConfigurationStateService = inject(LandingpageConfigurationStateService);
  const authenticationStateService = inject(AuthenticationStateService);

  if (landingpageConfigurationStateService.hasLandingpageConfiguration()) {
    return true;
  }

  if (!authenticationStateService.personalAccessToken()) {
    // The parent route's PersonalAccessTokenGuard has already run, but it only re-runs when the
    // parent is entered, not on every sibling navigation. Fail closed rather than fetch without
    // a token.
    return router.parseUrl('/');
  }

  try {
    await landingpageConfigurationStateService.fetchLandingpageConfiguration();
    return true;
  } catch (error) {
    if (error instanceof Error && error.message === BackendErrorType.SERVER_ERROR) {
      // errorInterceptor already navigates to the error page; cancel this navigation without
      // racing it with a second one.
      return false;
    }
    sessionStorage.clear();
    return router.parseUrl('/');
  }
};
